/**
 * Ensures the given value is a number, and it is finite (not Infinity or NaN)
 */
export const isFiniteNumber = (it: unknown): it is number => {
  return typeof it === 'number' && isFinite(it)
}
